import React from 'react';
const PHYSICIANS = [{
  name: 'Dr. Elena Morales',
  credentials: 'MD, FACOG',
  specialty: 'Perimenopause & hormone therapy',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=600&q=80'
}, {
  name: 'Dr. Aisha Patel',
  credentials: 'MD, MPH',
  specialty: "Women's endocrinology",
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&q=80'
}, {
  name: 'Dr. Sarah Whitfield',
  credentials: 'MD, NAMS-certified',
  specialty: 'Menopause transition care',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80'
}, {
  name: 'Dr. Monica Chen',
  credentials: 'MD, FACOG',
  specialty: 'Reproductive & hormonal health',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80'
}];
export function Physicians() {
  return <section className="w-full bg-orla-bone py-32 md:py-[128px] px-6" data-id="element-274">
      <div className="max-w-[1240px] mx-auto" data-id="element-275">
        {/* Header */}
        <div className="flex flex-row justify-between items-end mb-12" data-id="element-276">
          <div data-id="element-277">
            <p className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em] mb-3" data-id="element-278">
              THE TEAM
            </p>
            <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-[-0.02em] leading-tight" data-id="element-279">
              Meet the physicians.
            </h2>
          </div>
          <a href="#" className="hidden md:block font-body font-semibold text-[15px] text-orla-saffron hover:underline transition-all duration-200" data-id="element-280">
            View all physicians →
          </a>
        </div>

        {/* Physician Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:overflow-visible overflow-x-auto snap-x snap-mandatory md:snap-none" data-id="element-281">
          {PHYSICIANS.map((physician, index) => <div key={index} className="bg-orla-surface rounded-2xl shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-out cursor-pointer overflow-hidden snap-start min-w-[calc(66.67%-12px)] md:min-w-0" data-id="element-282">
              {/* Portrait Photo */}
              <div className="aspect-[3/4] overflow-hidden" data-id="element-283">
                <img src={physician.image} alt={physician.name} className="w-full h-full object-cover" data-id="element-284" />
              </div>

              {/* Content */}
              <div className="p-5" data-id="element-285">
                <h3 className="font-display font-semibold text-[18px] text-orla-ink mb-1" data-id="element-286">
                  {physician.name}
                </h3>
                <p className="font-body font-medium text-[13px] text-orla-muted mb-2" data-id="element-287">
                  {physician.credentials}
                </p>
                <p className="font-body italic text-[13px] text-orla-saffron" data-id="element-288">
                  {physician.specialty}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}